import "./Navbar.css";
import Dropdown from "react-bootstrap/Dropdown";
import "react-dropdown/style.css";
import MainLogo from "../../assets/images/logo3PL.svg";
import Mobile_Logo from "../../assets/images/3plLogo.svg";
import MainLogoAi from "../../assets/images/dashBoardLogo2.svg";
import CustomToggle from "../common/CustomMenu";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/actions/auth";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getLoginUserDetailsonFund,
} from "../../store/actions/fundManagement";
import _ from "lodash";
import { checkPermission, findIsHostShipAi, formatNumberWithCommas } from "../../config/utils";
import SellerDropdown from "./SellerDropDown";
import { Spinner } from "react-bootstrap";
import { FEATURE_WALLETBALANCEDISPLAY, featureSubmodulePermission, orderManagement, permssionCreate, permssionEdit, permssionView, shipmentModule, SUBF_WALLETBALANCEDISPLAY } from "../../constant";
import SidebarShipment from "../common/ShipmentDetailDrawer";
import Notifications from "../Notifications";

const getCurrentCompanySellerId = () => {
  try {
    return JSON.parse(localStorage.getItem('currentCompany'))?.companySellerId || null;
  } catch {
    return null;
  }
};

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState(0);
  const [show, setShow] = useState(false);
  const fundTransactionData = useSelector(
    (state) => state?.FundManagementReducer?.getWalletAmount
  );
  const { cartItems } = useSelector((state) => state.shipment);
  const userDetail = useSelector((state) => state.auth.user);
  const { showLoader } = useSelector((state) => state.auth);
  const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
  const userInfo = userDetail?.Value;
  const companySellerId = userInfo?.companySellerId || getCurrentCompanySellerId();
  const options = [{
    name: 'Enable backdrop (default)',
    scroll: false,
    backdrop: true,
  }];

  useEffect(() => {
    if (!userInfo) return;
    dispatch(
      getLoginUserDetailsonFund({
        creditCompanySellerId: companySellerId,
      })
    );
  }, [dispatch, userInfo, companySellerId]);

  /**
   * Close Drawer
   */
  const handleClose = () => {
    setShow(false);
  };

  /**
   * Get Funds for logged in user
   */
  const getFunds = () => {
    if (!userInfo) return;
    const activeCompanySellerId = userDetail?.Value?.companySellerId || getCurrentCompanySellerId();
    dispatch(
      getLoginUserDetailsonFund({
        creditCompanySellerId: activeCompanySellerId,
      })
    );
  }
  /**
   * Logout user
   */
  const handleLogout = () => {
    localStorage.clear();
    dispatch(logout());
    navigate("/");
  };

  /**
   * Navigate User to fundmanagement page
   * @param {String} type 
   */
  const handleNavigate = (type) => {
    if (type === 'ship') {
      setShow(!show);
    } else {
      setCurrentView(currentView + 1);
      navigate("/fundManagement", {
        state: {
          userData: fundTransactionData,
          currentView
        },
      });
    }
  };

  /**
   * Render Wallet Balance Section
   */
  const renderWalletBalanceSection = () => {
    const hasEditPermission = checkPermission(FEATURE_WALLETBALANCEDISPLAY, SUBF_WALLETBALANCEDISPLAY, permssionEdit, featureSubmodulePermission, employeePermissions)
    const hasViewPermission = checkPermission(FEATURE_WALLETBALANCEDISPLAY, SUBF_WALLETBALANCEDISPLAY, permssionView, featureSubmodulePermission, employeePermissions)
    if (hasEditPermission) {
      return (
        <button 
          className="walletBalanceSection" 
          onClick={handleNavigate}
          aria-label="View wallet balance details"
          type="button"
          style={{
            border: 'none',
            cursor: 'pointer',
            display: 'inline-block',
          }}
        >
          <span>Wallet Balance</span>${" "}
          {fundTransactionData
            ? formatNumberWithCommas(fundTransactionData?.balanceAmount)
            : 0}
        </button>
      );
    } else if (hasViewPermission) {
      return (
        <button
          className="walletBalanceSection viewOnlyFund"
          onClick={handleNavigate}
          aria-label="View wallet balance details"
          type="button"
          style={{
            border: 'none',
            cursor: 'pointer',
            display: 'inline-block',
          }}
        >
          <span>Wallet Balance</span>{" $ "}
          {fundTransactionData
            ? formatNumberWithCommas(fundTransactionData?.balanceAmount)
            : 0}
        </button>
      );
    } else {
      return null;
    }
  }

  /**
   * Render Ship Orders Section
   */
  const renderShipOrders = () => {
    return (
      <button 
        className="walletBalanceSection cart" 
        onClick={() => handleNavigate('ship')}
        aria-label="Open shipping cart"
        type="button"
        style={{
            border: 'none',
            cursor: 'pointer',
            display: 'inline-block',
          }}
      >
        <span><i className="fa fa-truck fa-flip-horizontal fnt15" aria-hidden="true"></i> Ship</span>
        {cartItems.length} Item(s)
      </button>
    )
  }

  return (
    <>
      {showLoader && (
        <div className="fullPageLoader">
          <div className="loaderContainer">
            <Spinner animation='border' size='lg' variant="primary" />;
          </div>
        </div>
      )}
      <nav className="navbars cus-header-sec">
        <div className="cus-header-left-sec desktopOnly">
          <img alt="" className="cus-main-logo-img maxHeight40" src={findIsHostShipAi() ? MainLogoAi : MainLogo} />
        </div>

        <div className="cus-header-left-sec mobDevices">
          <img alt="" className="cus-main-logo-img maxHeight40" src={Mobile_Logo} />
        </div>
        <div className="cus-header-right-sec">
          <div className="cus-loggedin-user-sec custom-algn-middle">
            <SellerDropdown getFunds={getFunds} navigate={navigate} />
            {checkPermission(orderManagement, shipmentModule, permssionCreate, featureSubmodulePermission, employeePermissions) && (
              <>{renderShipOrders()}</>
            )}
            {renderWalletBalanceSection()}
            {!findIsHostShipAi() && (
              <Notifications />
            )}
            <div className="userDetailSection">
              <Dropdown>
                <Dropdown.Toggle
                  as={CustomToggle}
                  id="dropdown-custom-components"
                  className="userMenu"
                >
                  <span>
                    {userDetail?.Value?.userName?.split(" ")[0].charAt(0).toUpperCase()}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div className="cus-profile-info-sec">
                    <div className="cus-profile-box">
                      <div className="cus-company-sec"></div>
                      <div className="cus-logout-sec">
                        <a
                          href="/#"
                          rel=""
                          className="dropdown-item"
                          onClick={handleLogout}
                        >
                          Logout
                        </a>
                      </div>
                    </div>
                    <div className="cus-profile-info-name">
                      <div className="cus-profile-circle-sec">
                        <span>
                          {userDetail?.Value?.userName?.split(" ")[0]
                              .charAt(0)
                              .toUpperCase()}
                        </span>
                      </div>
                      <div className="cus-profile-detail-sec">
                        <div className="cus-profile-name-sec">
                          {_.startCase(_.toLower(userDetail?.Value?.userName))}
                        </div>
                        <div className="cus-profile-email-sec">
                          {userDetail?.Value?.emailId}
                        </div>
                      </div>
                    </div>
                    <div className="cus-details">
                      {userDetail?.Value?.sellerName && (
                        <div className="cus-profile-name-sec">
                          Seller : {userDetail?.Value?.sellerName}
                        </div>
                      )}
                      {userDetail?.Value?.companyName && (
                        <div className="cus-profile-name-sec">
                          Company : {userDetail?.Value?.companyName}
                        </div>
                      )}
                      <div className="cus-profile-name-sec">
                        Role : {userDetail?.Value?.roleName}
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </nav>

      <SidebarShipment show={show} setShow={setShow} closeDrawer={handleClose} options={options} />
    </>
  );
};

export default Navbar;
